// extracted by mini-css-extract-plugin
export default {"edit":"edit_edit__blvCJ","content":"edit_content__yDfh7","rotate":"edit_rotate__zYsqp"};